exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__value___H6aCb {\n  background-color: #f2f2f2;\n  width: 100%;\n  border-radius: 5px; }\n", ""]);

// exports
exports.locals = {
	"value": "style__value___H6aCb"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/IndexSelect/style.scss
// module id = 4177
// module chunks = 6